import { Tag } from '@playq/octopus-common';

export const getTagLabel = (tag: Tag): string => {
  return tag.value ? `${tag.key}:${tag.value}` : tag.key;
};
